import { NgModule,} from '@angular/core';
import {GenericDataViewListPageModule} from "./generic-data-view-list/generic-data-view-list.page.module";
import {GenericDataViewDetailsPageModule} from "./generic-data-view-details/generic-data-view-details.page.module";
import {GenericDataViewTablePageModule} from "./generic-data-view-table/generic-data-view-table.page.module";


@NgModule({
  declarations: [],
  imports: [GenericDataViewListPageModule, GenericDataViewDetailsPageModule, GenericDataViewTablePageModule],
  entryComponents: [],
  providers: [],
})
export class GenericDataViewModule {}



// WEBPACK FOOTER //
// ./src/generic-data-view/generic-data-view.module.ts